/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_SkuInputs */

const vi_product_sku = /** @type {(inputs: Product_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã hàng`)
};

/**

* @param {Product_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_sku = /** @type {((inputs?: Product_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_sku(inputs)
});